// extracted by mini-css-extract-plugin
module.exports = {"story":"Story_story__2l4kv","text":"Story_text__15VEY"};